import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Language, type LanguageValue } from '@paladin-monorepo/common';

import {
  applyDocumentLanguage,
  setStoredLanguage,
} from '@/i18n/language';
import API from '@/lib/api';
import { useAuth } from '@/lib/auth';

export function useLanguage() {
  const { i18n } = useTranslation();
  const { user } = useAuth({ tmp: 'useLanguage' });
  const language = (i18n.language?.startsWith('en') ? Language.EN : Language.CS) as LanguageValue;

  const setLanguage = useCallback(
    async (nextLanguage: LanguageValue) => {
      setStoredLanguage(nextLanguage);
      applyDocumentLanguage(nextLanguage);
      await i18n.changeLanguage(nextLanguage);

      if (user) {
        try {
          await API.patch('/me/account/language', { language: nextLanguage });
        } catch {
          // Language still applies locally even if account sync fails.
        }
      }
    },
    [i18n, user],
  );

  return {
    language,
    setLanguage,
  };
}
